/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section_2_Term_ServicesInputs */

const en_terms_section_2_term_services = /** @type {(inputs: Terms_Section_2_Term_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`“Services”`)
};

const lv_terms_section_2_term_services = /** @type {(inputs: Terms_Section_2_Term_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`„Pakalpojumi”`)
};

/**
* | output |
* | --- |
* | "“Services”" |
*
* @param {Terms_Section_2_Term_ServicesInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const terms_section_2_term_services = /** @type {((inputs?: Terms_Section_2_Term_ServicesInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section_2_Term_ServicesInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_terms_section_2_term_services(inputs)
	return en_terms_section_2_term_services(inputs)
});